export const SurveilanceRouting = [
    {
        path: "/inspection/surveilance",
        name: "inspection-surveilance",
        meta:{
            title:'工地视频监控'
        },
        component: () => import("@/views/inspection-management/surveilance-video/list/surveillance-video.vue"),
    },
    {
        path: "/inspection/monitor-list",
        name: "inspection-monitor-list",
        meta:{
            title:'监控列表'
        },
        component: () => import("@/views/inspection-management/surveilance-video/list/monitor-list.vue"),
    },
    {
        path: "/inspection/create",
        name: "inspection-create",
        meta:{
            title:'新增摄像头'
        },
        component: () => import("@/views/inspection-management/surveilance-video/form/form.vue"),
    },
    {
        path: "/inspection/edit/:id",
        name: "inspection-edit",
        meta:{
            title:'编辑摄像头'
        },
        component: () => import("@/views/inspection-management/surveilance-video/form/form.vue"),
    }
];